import { FC } from 'react';

import { useRedirectToNonNewDesignRoute } from '../newDesignPages/irshPages/hooks/useRedirectToNonNewDesignRoute';

export const RedirectWithoutNewDesign: FC = () => {
  useRedirectToNonNewDesignRoute();

  return null;
};
